module.exports = __webpack_public_path__ + "img/integrationPanelIcon.3af3101a.svg";